<template id="CTAButton">
    <div class="quizier-module module-cta-button">
        <button-module :block_id="block_id" :post_id="postID" :button="button" />
    </div>
</template>
<script>
import mixinComponent from "../mixins";
import buttonModule from "../libs/ctaButtonModule.vue";

export default {
    props: [],
    mixins: [mixinComponent],
    components: {
        buttonModule
    },
    computed: {
        button: function() {
            return this.blockData;
        },
        block_id: function() {
            return this.me.index;
        }
    },
    methods: {
        updateButton: function(button) {
            this._updateValue('data', button);
        }
    },
};
</script>
